export const rootNode = document.getElementById('prospect-top-sdks-report');

export const initParams = () => ({
  generalData: JSON.parse(rootNode.dataset.data),
  report: JSON.parse(rootNode.dataset.report),
  defaultOsName: rootNode.dataset.defaultOsName,
  store: rootNode.dataset.store,
  shareOptions: JSON.parse(rootNode.dataset.shareOptions),
  data: JSON.parse(rootNode.dataset.data),
});

export const parseUrlForFilters = () => {
  const { pathname } = window.location;
  const allFilters = pathname.match(
    /\/top-charts\/top-sdks\/(google-play|itunes-connect)\/([a-z-]+)?/
  );
  const defaultFilters = pathname.match(/\/top-charts\/top-sdks/);
  let filters = { store: 'itunes-connect' };
  if (allFilters) {
    filters = { store: allFilters[1], function_id: allFilters[2] };
  }

  if (!allFilters && defaultFilters) {
    filters = { store: defaultFilters[1] };
  }
  return filters;
};
